<template>
  <v-app>
    <v-content>
      <v-container fluid>
        <v-layout align-center justify-center>
          <v-card style="width: 500px">
            <v-responsive :aspect-ratio="16 / 9">
              <v-card-title primary-title>
                <div>
                  <div class="headline pl-2 pa-1">{{ $t("customers.createCompany.heading") }}</div>
                </div>
              </v-card-title>
              <v-form ref="form" v-model="form" class="pa-4 pt-6">
                <v-flex>
                  <v-text-field
                    outline
                    v-model="model.company_name"
                    :rules="[rules.required]"
                    :label="$t('customers.createCompany.companyName')"
                    type="text"
                  ></v-text-field>
                </v-flex>
                <v-flex>
                  <v-text-field
                    outline
                    v-model="model.full_name"
                    :rules="[rules.required]"
                    :label="$t('customers.createCompany.managerFullName')"
                    type="text"
                  ></v-text-field>
                </v-flex>
                <v-flex>
                  <v-text-field
                    outline
                    v-model="model.username"
                    :rules="[rules.email]"
                    :label="$t('customers.createCompany.email')"
                    type="email"
                  ></v-text-field>
                </v-flex>
                <v-flex>
                  <v-text-field
                    outline
                    v-model="model.password"
                    :rules="[rules.password]"
                    :label="$t('customers.createCompany.password')"
                    type="password"
                    dense
                  ></v-text-field
                ></v-flex>
                <v-flex>
                  <v-autocomplete
                    v-model="returnObject"
                    clearable
                    :items="addresses"
                    :loading="isLoading"
                    :search-input.sync="search"
                    outline
                    dense
                    :label="$t('customers.createCompany.address')"
                    item-text="text"
                    item-value="text"
                    :placeholder="$t('customers.createCompany.addressPlaceholder')"
                    no-filter
                    return-object
                  >
                    <template slot="item" slot-scope="addresses">
                      <v-list-tile-content>
                        <v-list-tile-title
                          v-html="addresses.item.text"
                        ></v-list-tile-title>
                      </v-list-tile-content>
                    </template>
                  </v-autocomplete>
                </v-flex>
                <v-flex>
                  <v-text-field
                    outline
                    v-model="model.phone_number"
                    :rules="[rules.required]"
                    :label="$t('customers.createCompany.phoneNumber')"
                    type="text"
                    dense
                  ></v-text-field>
                </v-flex>
                <v-flex>
                  <v-text-field
                    outline
                    v-model="model.billing_email"
                    :rules="[rules.required]"
                    :label="$t('customers.createCompany.businessEmail')"
                    type="text"
                    dense
                  ></v-text-field>
                </v-flex>

                <v-btn
                  :loading="loading"
                  block
                  @click="createCompany"
                  color="secondary"
                  dark
                  >{{ $t("common.create") }}</v-btn
                >
              </v-form>
            </v-responsive>
          </v-card>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import axios from "axios";

export default {
  title() {
    return this.$t("customers.createCompany.title");
  },
  data: () => ({
    address: "",
    addresses: [],
    results: [],
    allResults: [],
    isLoading: false,
    search: null,
    loading: false,
    error: false,
    model: {
      full_name: "",
      company_name: "",
      username: "",
      password: "",
      address: "",
      pickup_location: {
        type: "Point",
        coordinates: [],
      },
      phone_number: "",
      billing_email: "",
      passenger_type: "COMPANY",
      landmark: "",
    },
    email: undefined,
    form: false,
    isLoading: false,
    password: undefined,
  }),
  computed: {
    rules() {
      return {
        email: (v) => !!(v || "").match(/@/) || this.$t("customers.createCompany.validEmail"),
        length: (len) => (v) =>
          (v || "").length >= len || this.$t("customers.createCompany.invalidLength", { length: len }),
        password: (v) =>
          !!(v || "").match(/^.{8,15}$/) || this.$t("customers.createCompany.passwordLength"),
        phoneNumber: (v) =>
          (!!v &&
            v.search(/^(\+0?1\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/) !== -1) ||
          this.$t("customers.createCompany.invalidPhone"),
        website: (v) =>
          !!(v || "").match(
            /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/
          ) || this.$t("customers.createCompany.invalidWebsite"),

        required: (v) => !!v || this.$t("customers.createCompany.requiredField"),
      };
    },
  },
  mounted() {
    // document.getElementById("location").placeholder = "";
    // const location = new google.maps.places.Autocomplete(
    //   document.getElementById("location")
    //   // {
    //   //   bounds: new google.maps.LatLngBounds(
    //   //     new google.maps.LatLng(45.4215296, -75.6971931)
    //   //   ),
    //   // }
    // );
    // location.addListener("place_changed", () => {
    //   const lat = location.getPlace().geometry.location.lat();
    //   const long = location.getPlace().geometry.location.lng();
    //   // console.log(location.getPlace());
    //   this.model.address = location.getPlace().formatted_address;
    //   // this.model.pickup_location = [lat, long];
    //   // this.model.pickup_location.coordinates = [lat, lng];
    //   this.model.pickup_location.coordinates.push(lat);
    //   this.model.pickup_location.coordinates.push(long);
    //   console.log(this.model.pick_up_location);
    //   // console.log(long);
    // });
  },
  watch: {
    search(val) {
      this.isLoading = true;
      const params = new URLSearchParams(this.initialSearchParams);
      params.append("address", val);
      this.axios
        .get("address", { params })
        .then((res) => {
          this.addresses = res.data.data.map((item) => ({
            text:
              `${item.name || ""}` +
              " " +
              `${item.street_name || ""}` +
              " " +
              `${item.street_number || ""}`,
            ...item,
          }));
        })
        .catch((err) => console.log(err))
        .finally(() => (this.isLoading = false));
    },
  },
  methods: {
    createCompany() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        var ret = this.returnObject.text.replace("null ", "");
        this.model.address = ret;
        if (this.returnObject.name)
          this.model.landmark = this.returnObject.name;
        else if (this.returnObject.street_name)
          this.model.landmark = this.returnObject.street_name;

        this.model.pickup_location.coordinates.push(
          this.returnObject.centroid.coordinates[0]
        );
        this.model.pickup_location.coordinates.push(
          this.returnObject.centroid.coordinates[1]
        );
        this.axios
          .post(this.api.ACTIONS.CREATE_PASSENGER, {
            ...this.model,
            provider: "users",
          })
          .then(() => {
            window.getApp.$emit("SHOW_TOAST", this.$t("customers.createCompany.companyCreated"), "green");
            this.$router.push("/companies");
          })
          .catch((err) => {
            console.log(err.message);
            this.error = true;
            let response = err.response;
            if (response) {
              window.getApp.$emit("SHOW_TOAST", response.data.message, "red");
              console.log(response.data);
            } else {
              window.getApp.$emit("SHOW_TOAST", this.$t("customers.createCompany.checkInfo"), "red");
            }
          })
          .then(() => (this.loading = false));

        console.log(this.model);
      }
    },
  },
};
</script>
